/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl, defaultAlerts, defaultLogs} from '../../../helpers'
import moment from 'moment'
import useNotifications from '../../../../hooks/useNotifications'
import {FormattedMessage, useIntl} from 'react-intl'
import useAuth from '../../../../hooks/useAuth'

const HeaderNotificationsMenu: FC = () => {
  const {notifications, fetchNotifications, handleUnseenNotification} = useNotifications()
  const intl = useIntl()
  const {me} = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div className='tab-content'>
        <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
          <div className='scroll-y mh-325px my-5 px-8'>
            {notifications.length ? (
              notifications
                .filter(
                  (notif) =>
                    notif.notificationType === 'ADD_EXERCICE' ||
                    notif.notificationType === 'DONE_EXERCICE' ||
                    notif.notificationType === 'ADD_REMARQUE'
                )
                .map((notification) => (
                  <div
                    key={notification._id}
                    className={`d-flex flex-stack py-4 ${
                      notification.read ? '' : 'bg-light _cursor-pointer mb-2'
                    }`}
                    onClick={() => {
                      handleUnseenNotification({
                        notificationId: notification._id,
                      }).then(() => {
                        fetchNotifications({recipient: me?._id!})
                      })
                    }}
                  >
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-35px me-4'>
                        {/*<span className={clsx('symbol-label', `bg-light-${alert.state}`)}>
                      <KTSVG
                        path={`/media/${alert.icon}`}
                        className={`svg-icon-2 svg-icon-${alert.state}`}
                      />
            </span> */}
                      </div>

                      <div className='mb-0 me-2'>
                        <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                          {notification.notificationType === 'ADD_EXERCICE' ? (
                            <FormattedMessage id='NOTIFICATION.ADD_EXERCICE.TITLE' />
                          ) : notification.notificationType === 'DONE_EXERCICE' ? (
                            <FormattedMessage id='NOTIFICATION.DONE_EXERCICE.TITLE' />
                          ) : notification.notificationType === 'ADD_REMARQUE' ? (
                            <FormattedMessage id='MENU.REMARQUE' />
                          ) : (
                            <></>
                          )}
                        </a>
                        <div className='text-gray-400 fs-7'>
                          {notification.notificationType === 'ADD_EXERCICE' ? (
                            intl.formatMessage(
                              {id: 'NOTIFICATION.ADD.EXERCICE'},
                              {
                                exercice: <b>{notification.exercice?.title}</b>,
                                classroom: notification.exercice?.classrooms?.map((classe, key) => (
                                  <>
                                    <b>{classe.name}</b>{' '}
                                    {key < notification.exercice.classrooms.length - 2
                                      ? ', '
                                      : key < notification.exercice.classrooms.length - 1
                                      ? intl.formatMessage({id: 'MENU.AND'}) + ' '
                                      : ''}
                                  </>
                                )),
                                subject: <b>{notification.exercice?.subject.name}</b>,
                              }
                            )
                          ) : notification.notificationType === 'DONE_EXERCICE' ? (
                            intl.formatMessage(
                              {id: 'NOTIFICATION.DONE.EXERCICE'},
                              {
                                classroom: notification.exercice?.classrooms?.map((classe, key) => (
                                  <>
                                    <b>{classe.name}</b>{' '}
                                    {key < notification.exercice.classrooms.length - 2
                                      ? ', '
                                      : key < notification.exercice.classrooms.length - 1
                                      ? intl.formatMessage({id: 'MENU.AND'}) + ' '
                                      : ''}
                                  </>
                                )),
                                exercice: <b>{notification.exercice?.title}</b>,
                                subject: <b>{notification.exercice?.subject?.name}</b>,
                              }
                            )
                          ) : notification.notificationType === 'ADD_REMARQUE' ? (
                            intl.formatMessage(
                              {id: 'NOTIFICATION.ADD.REMARQUE'},
                              {
                                type: <b>{notification.remarque?.type?.name}</b>,
                                from: notification.remarque?.administration ? (
                                  <b>{intl.formatMessage({id: 'MENU.THE_ADMIN'})}</b>
                                ) : (
                                  <b>{`${notification.remarque?.teacher?.firstName} ${notification.remarque?.teacher?.lastName}`}</b>
                                ),
                              }
                            )
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>

                    <span className='badge badge-light fs-8'>
                      {moment(notification.createdAt).fromNow(true)}
                    </span>
                  </div>
                ))
            ) : (
              <>
                {' '}
                <div className='mb-0 me-2'>
                  <div className='text-gray-600 fs-7'>
                    {intl.formatMessage({id: 'MENU.EMPTY_NOTIFICATIONS'})}
                  </div>
                </div>
              </>
            )}
            {/*defaultAlerts.map((alert, index) => (
              <div key={`alert${index}`} className='d-flex flex-stack py-4'>
                <div className='d-flex align-items-center'>
                   <div className='symbol symbol-35px me-4'>
                    <span className={clsx('symbol-label', `bg-light-${alert.state}`)}>
                      <KTSVG
                        path={`/media/${alert.icon}`}
                        className={`svg-icon-2 svg-icon-${alert.state}`}
                      />
                    </span>
            </div> 

                  <div className='mb-0 me-2'>
                    <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                      {alert.title}
                    </a>
                    <div className='text-gray-400 fs-7'>{alert.description}</div>
                  </div>
                </div>

                <span className='badge badge-light fs-8'>{alert.time}</span>
              </div>
            )) */}
          </div>
        </div>
      </div>
    </div>
  )
}

export {HeaderNotificationsMenu}
